<div style="background: white; border-radius: 16px; overflow: hidden;">
  <!-- Header -->
  <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 20px 24px; border-bottom: 2px solid #bbf7d0;">
    <div style="display: flex; align-items: center; justify-content: center; gap: 10px;">
      <mat-icon style="font-size: 24px; width: 24px; height: 24px; color: #1C593D;">edit</mat-icon>
      <span style="font-size: 1.1rem; font-weight: 800; color: #1e5a3f;">Editar datos</span>
    </div>
    <p style="text-align: center; font-size: 0.8rem; color: #6b7280; margin: 6px 0 0;">Actualiza tu información de contacto</p>
  </div>

  <!-- Form -->
  <div style="padding: 24px; max-height: 65vh; overflow-y: auto;">
    <form [formGroup]="datosForm" *ngIf="datosForm" (ngSubmit)="enviarDatos()">

      <!-- Sección: Datos personales -->
      <div style="margin-bottom: 20px;">
        <span style="font-size: 0.78rem; font-weight: 700; color: #1C593D; text-transform: uppercase; letter-spacing: 0.5px;">Datos Personales</span>
        <div style="border-top: 2px solid #bbf7d0; margin-top: 6px; padding-top: 16px;">
          <div class="form-row two-cols">
            <mat-form-field appearance="outline" class="modern-field">
              <mat-label>Nombre</mat-label>
              <mat-icon matPrefix style="color: #6b7280; margin-right: 4px;">person</mat-icon>
              <input type="text" matInput formControlName="nombre" placeholder="Ingresa tu nombre">
            </mat-form-field>
            <mat-form-field appearance="outline" class="modern-field">
              <mat-label>Apellidos</mat-label>
              <mat-icon matPrefix style="color: #6b7280; margin-right: 4px;">person_outline</mat-icon>
              <input type="text" matInput formControlName="apellido" placeholder="Ingresa tu apellido">
            </mat-form-field>
          </div>

          <div class="form-row two-cols">
            <mat-form-field appearance="outline" class="modern-field">
              <mat-label>Tipo documento</mat-label>
              <mat-icon matPrefix style="color: #6b7280; margin-right: 4px;">badge</mat-icon>
              <mat-select required formControlName="tipoId">
                <mat-option>Tipo documento</mat-option>
                <mat-option *ngFor="let tipoID of tiposID" [value]="tipoID">{{tipoID}}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="modern-field">
              <mat-label>Numero identificación</mat-label>
              <mat-icon matPrefix style="color: #6b7280; margin-right: 4px;">fingerprint</mat-icon>
              <input type="text" matInput formControlName="numeroId" placeholder="Ingresa tu documento">
            </mat-form-field>
          </div>

          <div class="form-row two-cols">
            <mat-form-field appearance="outline" class="modern-field">
              <mat-label>Sexo</mat-label>
              <mat-select required formControlName="sexo">
                <mat-option>Selecciona una opción</mat-option>
                <mat-option *ngFor="let sexo of sexos" [value]="sexo">{{sexo}}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="modern-field">
              <mat-icon matPrefix style="color: #6b7280; margin-right: 4px;">calendar_today</mat-icon>
              <input matInput placeholder="Fecha de nacimiento" [matDatepicker]="picker" formControlName="fechaNacimiento">
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>

          <div class="form-row two-cols">
            <mat-form-field appearance="outline" class="modern-field">
              <mat-label>Nacionalidad</mat-label>
              <mat-icon matPrefix style="color: #6b7280; margin-right: 4px;">flag</mat-icon>
              <mat-select required formControlName="nacionalidad">
                <mat-option>Selecciona un país</mat-option>
                <mat-option *ngFor="let pais of paises" [value]="pais.ALPHA2" class="flex flex-row">
                  <div [class]="'bg-' + pais.ALPHA2.toLowerCase()"></div>
                  <span>{{pais.NAME | titlecase}}</span>
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="modern-field">
              <mat-label>Profesión</mat-label>
              <mat-icon matPrefix style="color: #6b7280; margin-right: 4px;">work</mat-icon>
              <input type="text" matInput formControlName="profesion" placeholder="Ej. Ingeniero">
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Sección: Datos de contacto -->
      <div style="margin-bottom: 20px;">
        <span style="font-size: 0.78rem; font-weight: 700; color: #1C593D; text-transform: uppercase; letter-spacing: 0.5px;">Datos de Contacto</span>
        <div style="border-top: 2px solid #bbf7d0; margin-top: 6px; padding-top: 16px;">
          <div class="form-row two-cols">
            <mat-form-field appearance="outline" class="modern-field">
              <mat-label>País de residencia</mat-label>
              <mat-icon matPrefix style="color: #6b7280; margin-right: 4px;">public</mat-icon>
              <mat-select required formControlName="paisResidencia">
                <mat-option>Selecciona un país</mat-option>
                <mat-option *ngFor="let pais of paises" [value]="pais.ALPHA2" class="flex flex-row">
                  <div [class]="'bg-' + pais.ALPHA2.toLowerCase()"></div>
                  <span>{{pais.NAME | titlecase}}</span>
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="modern-field">
              <mat-label>Ciudad de residencia</mat-label>
              <mat-icon matPrefix style="color: #6b7280; margin-right: 4px;">location_city</mat-icon>
              <input type="text" matInput formControlName="ciudadResidencia" placeholder="Ej. Santiago">
            </mat-form-field>
          </div>

          <div class="form-row two-cols">
            <mat-form-field appearance="outline" class="modern-field">
              <mat-label>Código</mat-label>
              <mat-icon matPrefix style="color: #6b7280; margin-right: 4px;">phone</mat-icon>
              <mat-select required formControlName="prefijoTelefono">
                <mat-option>Selecciona un país</mat-option>
                <mat-option *ngFor="let pais of paises" [value]="pais.DIAL" class="flex flex-row">
                  <div [class]="'bg-' + pais.ALPHA2.toLowerCase()"></div>
                  <span>{{pais.DIAL}} - {{pais.NAME | titlecase}}</span>
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" class="modern-field">
              <mat-label>Teléfono</mat-label>
              <mat-icon matPrefix style="color: #6b7280; margin-right: 4px;">smartphone</mat-icon>
              <input type="text" matInput formControlName="telefono" placeholder="Ingresa tu Teléfono">
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline" class="modern-field">
              <mat-label>Dirección</mat-label>
              <mat-icon matPrefix style="color: #6b7280; margin-right: 4px;">home</mat-icon>
              <input type="text" matInput formControlName="direccion" placeholder="Ej. Av. Principal 123">
            </mat-form-field>
          </div>

          <div class="form-row">
            <mat-form-field appearance="outline" class="modern-field">
              <mat-label>Facturas</mat-label>
              <mat-icon matPrefix style="color: #6b7280; margin-right: 4px;">receipt</mat-icon>
              <mat-select required matInput formControlName="recibeFactura">
                <mat-option value="1">Facturas Activadas</mat-option>
                <mat-option value="0">Facturas Desactivadas</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Verificación del celular nuevo -->
      <p *ngIf="otpError && !otpStep" style="color: #b91c1c; font-size: 0.85rem; margin: 0 0 12px; text-align: center;">
        {{ otpError }}
      </p>
      <div *ngIf="otpStep" style="border: 1px solid #d1fae5; background: #f0fdf4; border-radius: 12px; padding: 16px; margin-bottom: 16px;">
        <p style="margin: 0 0 4px; font-weight: 700; color: #1C593D;">Verifica tu nuevo celular</p>
        <p style="margin: 0 0 12px; font-size: 0.85rem; color: #374151;">
          Te enviamos un código por WhatsApp al {{ otpPhone }}. Ingrésalo para guardar el cambio.
        </p>
        <mat-form-field appearance="outline" class="modern-field" style="width: 100%;">
          <mat-label>Código de 6 dígitos</mat-label>
          <input matInput [formControl]="otpCodeControl" inputmode="numeric" autocomplete="one-time-code" maxlength="6" placeholder="123456">
        </mat-form-field>
        <p *ngIf="otpError" style="color: #b91c1c; font-size: 0.85rem; margin: 4px 0 8px;">{{ otpError }}</p>
        <div style="display: flex; gap: 16px; flex-wrap: wrap; font-size: 0.85rem;">
          <button type="button" (click)="resendOtp()" [disabled]="otpCooldown > 0 || otpLoading"
            [style.opacity]="(otpCooldown > 0 || otpLoading) ? '0.5' : '1'"
            style="background: none; border: none; color: #1C593D; font-weight: 600; cursor: pointer; padding: 0;">
            {{ otpCooldown > 0 ? 'Reenviar código en ' + otpCooldown + ' s' : 'Reenviar código' }}
          </button>
          <button type="button" (click)="cancelOtp()"
            style="background: none; border: none; color: #6b7280; cursor: pointer; padding: 0;">
            Cambiar número
          </button>
        </div>
      </div>

      <!-- Buttons -->
      <div style="display: flex; justify-content: center; gap: 16px; padding-top: 8px; border-top: 1px solid #e5e7eb; flex-wrap: wrap;">
        <button type="button" (click)="close()"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 28px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
          onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
          Cancelar
        </button>
        <button type="submit" [disabled]="otpLoading" [style.opacity]="otpLoading ? '0.6' : '1'"
          style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
          onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">save</mat-icon>
          {{ otpStep ? 'Verificar y guardar' : 'Actualizar' }}
        </button>
      </div>
    </form>
  </div>
</div>
